/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import LodingLottie from '../Lodinglottie';
import PageHeader from './PageHeader';
import { FiFileText } from 'react-icons/fi';

const Terms_Conditions = () => {

    const { basUrl } = useContext(MyContext);

    const Perams = useParams();
    const Title = Perams.title?.replaceAll('_', ' ');
    const [list, setList] = useState([]);
    const selectedPage = list.find((item) => item.title.toLowerCase() === Title);

    const ApiHandler = useCallback(() => {
        axios.post(`${basUrl}pagelist`)
            .then((res) => {
                setList(res.data.pagelist);
            });
    }, [basUrl]);

    useEffect(() => {
        ApiHandler();
    }, [ApiHandler]);

    return (
        <div>
            <div className="main-wrapper bg-[#e5e5e5] dashboard">
                <div className="content-body min-h-screen">
                    <div className="container-fluid my-2 sm:my-4 px-2.5 sm:px-4">
                        {selectedPage && (
                            <div>
                                <PageHeader
                                    title={selectedPage.title}
                                    breadcrumbs={[{ label: selectedPage.title }]}
                                    icon={FiFileText}
                                />
                                <div className='bg-white p-[30px] max-_430_:p-[16px] rounded-2xl shadow-xs text-[15px] description border border-gray-200/80' dangerouslySetInnerHTML={{ __html: selectedPage?.description }} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {list.length === 0 && (
                <div className="w-[100%] h-[100vh] ms-[8rem] max-_991_:ms-0 bg-white fixed flex items-center justify-center top-0 left-0 right-0 bottom-0 z-[555]">
                    <LodingLottie ClassCss={"w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]"} />
                </div>
            )}
        </div>
    );
}

export default Terms_Conditions
/* jshint ignore:end */
